class App {
  constructor() {
    this.preDefinedApps = {
      BLUETOOTH: "244115188075859015",
      USB: "201604211753030001",
      MIRACAST: "144115188075855880",
      YOUTUBE: "144115188075859002",
      BROWSER: "144115188075855877"
    }
  }
  _init = async () => {
    return true
  }

  getList = async () => {
    let promise = await _$.progress.create()

    /* Library Code */
    hcap.preloadedApplication.getPreloadedApplicationList({
      onSuccess: payload => promise.resolve(payload.list),
      onFailure: payload => promise.reject(payload.errorMessage)
    })
    /* Library Code */

    const res = await promise.done
    if (!res) return res

    const applist = []
    res.forEach(app => applist.push({ key: app.id, value: app.title }))

    hcap.application.RegisterSIApplicationList({
      tokenList: [
        {
          id: "netflix",
          token:
            "D81yTIxm4JBBr7mINZRdHPL3bL5ZyEMyE8OQAxfPsY7P0RmhbfBaivocfKtlB8Te8KgKvqI5j8rWO4j7Sf6fvBIdaLVjEzTcVp+LQiIEA/eL9Gm321Vo+4NumYpgYLLTs/g1ANA0iQtVQcDy1l/GNT6Q/nbnYr20SYD+0ev2czad5kAPCc7ILWrnF51S8viYw9uyzNnJHUsqAd7y6SSbpI5TR804SgKIkjFIKN/Ew+eCbG33L2G6Ht7DooC5FvFlBeZIf0BtoGQqt/I2VLgH8YEHhPAtpdI+zWTEFm5lZVjgpEx86I4mhtbn+6zemrio+JxE3gfM6u54ivGkCpEVRQ=="
        }
      ],
      onSuccess: () => applist.push({ key: "244115188075859013", value: "Netflix" }),
      onFailure: () => {}
    })

    return applist
  }
  launch = async app_id => {
    if (!app_id) return false
    let promise = await _$.progress.create()
    await __.platform.unfocusing()

    _$.vue.$once("applicationUnfocused", () => promise.resolve())

    /* Library Code */
    const payload = {
      id: app_id.toString(),
      onFailure: payload => promise.reject(payload.errorMessage)
    }

    if (payload.id === "244115188075859013") payload.parameters = "{'reason':'launcher','params':{'hotel_id':'7260692151','launcher_version':'1.0'}}"
    hcap.preloadedApplication.launchPreloadedApplication(payload)
    /* Library Code */

    return promise.done
  }
  close = async () => {
    let promise = await _$.progress.create()

    _$.vue.$once("applicationFocusing", () => promise.resolve())

    hcap.preloadedApplication.destroyPreloadedApplication({
      id: __.app.isLaunched,
      onFailure: () => {
        hcap.key.sendKey({
          virtualKeycode: hcap.key.Code.EXIT,
          onFailure: payload => promise.reject(payload.errorMessage)
        })
      }
    })

    return promise.done
  }
}

export default App
